export default "__VITE_ASSET__Dmc1IL63__"